// 分组相关
export const GET_GROUP_LIST = 'GET_GROUP_LIST'
export const GET_SERVICE_LIST = 'GET_SERVICE_LIST'
export const SET_GROUP_LIST = 'SET_GROUP_LIST'
export const CREATE_GROUP = 'CREATE_GROUP'
export const EDIT_GROUP = 'EDIT_GROUP'
export const DELETE_GROUP = 'DELETE_GROUP'

export const GET_SERVICE_DETAIL = 'GET_SERVICE_DETAIL'
export const REFRESH_SERVICE_DETAIL = 'REFRESH_SERVICE_DETAIL'

export const ADD_SERVICE = 'ADD_SERVICE'
export const EDIT_SERVICE = 'EDIT_SERVICE'
export const DELETE_SERVICE = 'DELETE_SERVICE'
export const DATA_COMPONENT = 'DATA_COMPONENT'
